import { useContext } from 'react'
import { AuthContext, StoreSettingsContext } from 'store'
import { apiRoutes } from 'config/apiRoutes'
import { useOptions } from 'shared/hooks/useOptions'

const bookingLabel = (booking: any) =>
	booking?.booth?.number
		? `#${booking.booth.number} ${booking.booth.booth_type.name} - (#${booking.ref_nr} ${booking.start_date})`
		: `#${booking.ref_nr} ${booking.start_date}`

export const useFilterOptions = () => {
	const { auth } = useContext(AuthContext)
	const storeCtx = useContext(StoreSettingsContext)
	const settings = storeCtx?.storeSettings
	const enabled = !!auth.accessToken

	return {
		categories: useOptions({
			name: 'fetchCategories',
			endpoint: '/categories/',
			enabled: enabled && !!settings?.categories_enabled
		}),
		fabrics: useOptions({
			name: 'fetchProductFabricTypes',
			endpoint: '/product-fabrics/',
			enabled: enabled && !!settings?.product_fabrics_enabled
		}),
		conditions: useOptions({
			name: 'fetchProductConditions',
			endpoint: '/product-conditions/',
			enabled: enabled && !!settings?.product_conditions_enabled
		}),
		genders: useOptions({
			name: 'fetchProductGenders',
			endpoint: '/product-genders/',
			enabled: enabled && !!settings?.product_genders_enabled
		}),
		types: useOptions({
			name: 'fetchProductTypes',
			endpoint: '/product-types/',
			enabled: enabled && !!settings?.product_types_enabled
		}),
		tags: useOptions({
			name: 'fetchInfiniteTags',
			endpoint: apiRoutes.tags(),
			enabled: enabled && !!settings?.tags_enabled
		}),
		bookings: useOptions({
			name: 'fetchBookings',
			endpoint: '/bookings/',
			query: 'is_active=true',
			enabled,
			getLabel: bookingLabel
		})
	}
}
